module.exports = "<div class=\"hide-next-elements\" layout=\"row\" layout-padding layout-sm=\"column\" layout-align=\"space-around\">\n    <md-progress-circular md-mode=\"indeterminate\"></md-progress-circular>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/md-loading.directive.html
// module id = 7
// module chunks = 0